export default __webpack_public_path__ + "static/media/Head.e4e1e885.svg";